import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { InputText } from "primereact/inputtext";
import { useHistory, useParams } from "react-router-dom";
import { handleGetRequest } from "../../services/GetTemplate";
import { clientType, PackageTypes, status, importStatus, exportAirStatus, exportSeaStatus, deliveryStatus, statusArray } from "../../assets/data/data";
import { handlePutRequest } from "../../services/PutTemplate";
import { toast } from "react-toastify";
import Barcode from "react-barcode";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase/firebase";
import Select from "react-select";
import useViewOnly from "../../hooks/useViewOnly";
import styles from "./packageDetail.module.scss";
import { checkInvoiceConflicts } from "../../services/invoiceConflictService";
import InvoiceConflictDialog from "../../components/InvoiceConflictDialog";

function Package() {
    const viewOnly = useViewOnly();
    const [brandData, setBrandData] = useState();
    const [clients, setClients] = useState([]);
    const [selectClients, setSelectedClients] = useState();
    const [couriers, setCouriers] = useState([]);
    const [selectedCouriers, setSelectedCouriers] = useState();
    const [selectedImportStatus, setSelectedImportStatus] = useState();
    const [selectedPackType, setSelectedPAckType] = useState();
    const [selectedDeliveryStatus, setSelectedDeliveryStatus] = useState();
    const [selectedUnit, setSelectedUnit] = useState();
    const [selectedShipment, setSlectedShipment] = useState();
    const [consigneeType, setConsigneeType] = useState(null);
    const [image, setImage] = useState();
    const [over, setOver] = useState();
    const history = useHistory();
    const { id } = useParams();
    const [role, setrole] = useState("");
    const isDriver = role === "driver"; // read-only access
    const canEdit = role === "admin" || ((role === "clerk" || role === "handler") && !viewOnly);
    const [delivery, setDelivery] = useState();
    const [images, setImages] = useState([]);
    const [DeliveryInfos, setDeliveryInfos] = useState([]);
    const [packageStatus, setPackageStatus] = useState([]);
    const [users, setUsers] = useState([]);
    // Invoices uploaded before contentType was set on upload have no/incorrect
    // image MIME type in Firebase Storage, so the browser can't render them as
    // an <img>. Fall back to a plain link for those instead of a broken image.
    const [invoiceImgError, setInvoiceImgError] = useState(false);

    const getDetails = async () => {
        const res = await handleGetRequest(`/package/${id}`);
        const rese = await handleGetRequest("/allUsers");
        const result = await handleGetRequest("/userRole?role=courier");
        const res2 = await handleGetRequest(`/getAllDeliveryInfo`);
        const resa = await handleGetRequest(`/getAllPackageStatus`);
        setPackageStatus(resa?.data);
        setDeliveryInfos(res2?.data);
        let df = [];
        let dt;
        dt = rese?.data?.forEach((val) => {
            df.push({
                label: val?.firstName + " " + val?.lastName,
                value: val?._id,
            });
            return null;
        });
        setUsers(rese?.data);
        setClients(df);
        setCouriers(result?.data);
        const keyData = res?.data;
        setBrandData(keyData);
        setSelectedClients({
            label: keyData?.name?.firstName + " " + keyData?.name?.lastName,
            value: keyData?.name?._id,
        });
        console.log("Key Data:", keyData?.packageStatus, resa?.data);
        setSelectedDeliveryStatus(keyData?.packageStatus);
        setSelectedPAckType(keyData?.packageType);
        setSelectedUnit(keyData?.weight?.unit);
        setSlectedShipment(keyData?.shipmentMethod);
        setConsigneeType(keyData?.consigneeType);
        setSelectedCouriers(keyData?.courierName?._id);
        setDelivery(keyData?.deliveryInfo);
        setImages(keyData?.notesImages);
    };
    useEffect(() => {
        getDetails();
        setInvoiceImgError(false);
    }, [id]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            Waybill: brandData?.Waybill ?? "",
            oversizePackage: "",
            name: "",
            consigneeName: brandData?.consigneeName ?? "",
            merchant: brandData?.merchant ?? "",
            description: brandData?.description ?? "",
            weight: brandData?.weight?.number ?? "",
            flightNumber: brandData?.flightNumber ?? "",
            status: "",
            courierName: "",
            shipmentMethod: "",
            packageType: "",
            unit: "",
            price: brandData?.price ?? "",
            shipmentNumber: brandData?.shipmentNumber ?? "",
            numberOfPieces: brandData?.numberOfPieces ?? "",
            consigneeType: brandData?.consigneeType ?? "",
            invoiceImage: "",
            import_status: "",
            export_sea_status: "",
            delivery_status: "",
            export_air_status: "",
            billTo: brandData?.billTo ?? "",
            trackingNumber: brandData?.trackingNumber ?? "",
            deliveryInfo: brandData?.deliveryInfo ?? "",
            notes: brandData?.notes ?? "",
            nameOfUser: "",
            courierNameOfUser: "",
            notesImages: [],
        },

        onSubmit: async (data) => {
            data.oversizePackage = over === "true" ? true : false;
            data.consigneeName = data?.consigneeName;
            data.number = data.weight;
            data.unit = selectedUnit;
            data.courierName = selectedCouriers;
            const temp1 = couriers?.filter((val) => val?._id === selectedCouriers);
            data.courierNameOfUser = temp1[0]?.courier?.businessName;
            data.shipmentMethod = selectedShipment;
            data.packageType = selectedPackType;
            data.consigneeType = consigneeType;
            data.name = selectClients?.value;
            const temp = clients?.filter((val) => val?._id === selectClients?.value);
            data.nameOfUser = temp[0]?.firstName + " " + temp[0]?.lastName;
            data.deliveryInfo = delivery;
            data.notesImages = images;
            if (image) {
                data.invoiceImage = image;
            }
            const result = await handlePutRequest(data, "/editPackage");
            if (result?.success) {
                getDetails();
                toast.success("Package edited");
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handleCancel = () => {
        history.push("/customers");
    };

    const handleBack = () => {
        history.push("/packages");
    };

    useEffect(() => {
        const role = localStorage.getItem("role");
        setrole(role);
    }, []);

    const uploadImage = async (file) => {
        let name = file.name;
        let filename = name.replace(/\.[^/.]+$/, "") + "-" + Math.floor(Math.random() * 10000000 + 1);
        const storageRef = ref(storage, filename);
        await uploadBytes(storageRef, file, { contentType: file.type }).then((snapshot) => {});
        await getDownloadURL(storageRef).then(async (url) => {
            setImage(url);
            const data = {
                inventoryNumber: id,
                invoiceImage: url,
                invoiceuploaded: true,
            };
            const result = await handlePutRequest(data, "/editPackage");
            if (result?.success) {
                getDetails();
                toast.success("Package edited");
            }
        });
    };

    const [invoiceConflict, setInvoiceConflict] = useState([]);
    const [showInvoiceConflict, setShowInvoiceConflict] = useState(false);
    const [checkingInvoiceConflict, setCheckingInvoiceConflict] = useState(false);

    const submitStatusChange = async (e) => {
        if (brandData?.consigneeType === "client") {
            const data = {
                status: e,
                id,
                name: brandData?.name?.firstName + " " + brandData?.name?.lastName,
                deliveryAddress: brandData?.name?.client?.deliveryAddress,
                email: brandData?.name?.email,
                deliveryInfo: brandData?.deliveryInfo,
            };
            const res = await handlePutRequest(data, "/packageStatusChange");
            if (res?.success) {
                getDetails();
                toast.success("Package edited");
            }
        } else {
            const data = {
                status: e,
                id,
                name: brandData?.courierName?.courier?.businessName,
                email: brandData?.courierName?.email,
                deliveryInfo: brandData?.deliveryInfo,
            };
            const res = await handlePutRequest(data, "/packageStatusChange");
            if (res?.success) {
                getDetails();
                toast.success("Package edited");
            }
        }
    };

    const handledeliveryStatus = async (e) => {
        setSelectedImportStatus(e);

        if (e === "Ready for Flight") {
            setCheckingInvoiceConflict(true);
            let foundConflicts;
            try {
                foundConflicts = await checkInvoiceConflicts([id]);
            } finally {
                setCheckingInvoiceConflict(false);
            }
            if (foundConflicts.length > 0) {
                setInvoiceConflict(foundConflicts);
                setShowInvoiceConflict(true);
                return;
            }
        }

        await submitStatusChange(e);
    };

    // Only one package is in play here, so "remove from list" and "stop
    // altogether" are the same outcome - both just close the dialog without
    // submitting.
    const handleCancelInvoiceConflict = () => {
        setShowInvoiceConflict(false);
        setInvoiceConflict([]);
    };

    const handleProceedStatusOnly = async () => {
        setShowInvoiceConflict(false);
        await submitStatusChange(selectedImportStatus);
    };

    const handleRemove = (index) => {
        let temp = images;
        temp.splice(index, 1);
        setImages([...temp]);
    };

    console.log(brandData);

    const handleSelectedClients = (selectedOption) => {
        const consignee = users?.filter((val) => val?._id === selectedOption?.value);
        setSelectedClients(selectedOption);
        setConsigneeType(consignee?.[0]?.role);
    };

    return (
        <div className={styles.packagePageWrapper}>
            <div className={styles.pageHeaderCard}>
                <button type="button" className={styles.backLink} onClick={handleBack}>
                    <i className="pi pi-arrow-left" /> Back to Packages
                </button>
                <div className={styles.pageHeaderRow}>
                    <div>
                        <h2 className={styles.pageHeaderTitle}>{brandData?.title || `Package ${brandData?.Waybill || ""}`}</h2>
                        {brandData?.Waybill && <p className={styles.pageHeaderSubtitle}>Waybill #{brandData.Waybill}</p>}
                    </div>
                    {brandData?.packageStatus && <span className={styles.headerStatusBadge}>{brandData.packageStatus}</span>}
                </div>
            </div>
            {role === "client" && (
                <div className={styles.uploadCard}>
                    <div className={styles.fieldGroup}>
                        <label htmlFor="invoiceImage" className={classNames({ "p-error": isFormFieldValid("invoiceImage") }, "Label__Text")}>
                            Upload invoice Image
                        </label>
                        <InputText id="invoiceImage" type="file" name="invoiceImage" onChange={(e) => uploadImage(e.target.files[0])} className={classNames({ "p-invalid": isFormFieldValid("invoiceImage") }, "Input__Round")} />

                        {getFormErrorMessage("invoiceImage")}
                    </div>
                    {image && (
                        <div>
                            <img src={image} alt="Invoice" style={{ width: "30%", objectFit: "cover", marginTop: "20px", height: "50%" }}></img>
                        </div>
                    )}
                </div>
            )}
            <div className={styles.contentCard}>
                <div>
                    <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                        <div className={styles.formGrid}>
                            <div className={styles.formCol}>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="Waybill" className={classNames({ "p-error": isFormFieldValid("Waybill") }, "Label__Text")}>
                                        Way Bill
                                    </label>
                                    <InputText disabled id="Waybill" name="Waybill" value={formik.values.Waybill} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("Waybill") }, "Input__Round")} />

                                    {getFormErrorMessage("Waybill")}
                                </div>
                                {window.innerWidth > 768 && formik.values.Waybill && (
                                    <div className={styles.barcodeBox}>
                                        <Barcode value={formik.values.Waybill} height={50} />
                                    </div>
                                )}
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="description" className={classNames({ "p-error": isFormFieldValid("description") }, "Label__Text")}>
                                        Description
                                    </label>
                                    <InputText
                                        id="description"
                                        disabled={canEdit ? false : true}
                                        name="description"
                                        value={formik.values.description}
                                        onChange={formik.handleChange}
                                        className={classNames({ "p-invalid": isFormFieldValid("description") }, "Input__Round")}
                                    />

                                    {getFormErrorMessage("description")}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") }, "Label__Text")}>
                                        Bill To
                                    </label>
                                    <Select options={clients} value={selectClients} onChange={handleSelectedClients}></Select>
                                    {getFormErrorMessage("name")}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="merchant" className={classNames({ "p-error": isFormFieldValid("merchant") }, "Label__Text")}>
                                        Merchant Name
                                    </label>
                                    <InputText
                                        type="text"
                                        id="merchant"
                                        disabled={canEdit ? false : true}
                                        name="merchant"
                                        value={formik.values.merchant}
                                        onChange={formik.handleChange}
                                        className={classNames({ "p-invalid": isFormFieldValid("merchant") }, "Input__RoundFile")}
                                    />

                                    {getFormErrorMessage("merchant")}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="billTo" className={classNames({ "p-error": isFormFieldValid("billTo") }, "Label__Text")}>
                                        Package Name
                                    </label>
                                    <InputText type="text" id="billTo" disabled={canEdit ? false : true} name="billTo" value={formik.values.billTo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("billTo") }, "Input__RoundFile")} />

                                    {getFormErrorMessage("merchant")}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="trackingNumber" className={classNames({ "p-error": isFormFieldValid("trackingNumber") }, "Label__Text")}>
                                        Tracking Number
                                    </label>
                                    <InputText
                                        type="text"
                                        id="trackingNumber"
                                        disabled={canEdit ? false : true}
                                        name="trackingNumber"
                                        value={formik.values.trackingNumber}
                                        onChange={formik.handleChange}
                                        className={classNames({ "p-invalid": isFormFieldValid("trackingNumber") }, "Input__RoundFile")}
                                    />

                                    {getFormErrorMessage("merchant")}
                                </div>

                                <div className={styles.fieldGroup}>
                                    <label htmlFor="shipmentMethod" className={classNames({ "p-error": isFormFieldValid("shipmentMethod") }, "Label__Text")}>
                                        Shipment Method
                                    </label>
                                    <select className={styles.selectInput} disabled={canEdit ? false : true} value={selectedShipment} onChange={(e) => setSlectedShipment(e.target.value)}>
                                        <option disabled selected>
                                            Please select a shipment Method
                                        </option>
                                        <option value="shipment">shipment</option>
                                        <option value="air">Air</option>
                                    </select>

                                    {getFormErrorMessage("shipmentMethod")}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="shipmentMethod" className={classNames({ "p-error": isFormFieldValid("shipmentMethod") }, "Label__Text")}>
                                        Consignee Type
                                    </label>
                                    <select className={styles.selectInput} disabled={canEdit ? false : true} value={consigneeType} onChange={(e) => setConsigneeType(e.target.value)}>
                                        <option disabled selected>
                                            Please select a consignee Type
                                        </option>
                                        <option value="client">Client</option>
                                        <option value="courier">Courier</option>
                                        <option value="corporate">Corporate</option>
                                        <option value="reseller">Reseller</option>
                                        <option value="admin">Admin</option>
                                    </select>

                                    {getFormErrorMessage("shipmentMethod")}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="overSizedPackage" className={classNames({ "p-error": isFormFieldValid("overSizedPackage") }, "Label__Text")}>
                                        Oversized Package?
                                    </label>
                                    <select className={styles.selectInput} disabled={canEdit ? false : true} value={over === true ? true : false} onChange={(e) => setOver(e.target.value)}>
                                        <option disabled selected>
                                            Please select a package condition
                                        </option>
                                        <option value={true}>Yes</option>
                                        <option value={false}>No</option>
                                    </select>

                                    {getFormErrorMessage("overSizedPackage")}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="numberOfPieces" className={classNames({ "p-error": isFormFieldValid("numberOfPieces") }, "Label__Text")}>
                                        Delivery Information
                                    </label>
                                    <select className={styles.selectInput} value={delivery} onChange={(e) => setDelivery(e.target.value)}>
                                        <option disabled selected>
                                            Please select delivery Information
                                        </option>
                                        {DeliveryInfos?.map((client) => {
                                            return <option value={client?.name}>{client?.name}</option>;
                                        })}
                                    </select>

                                    {getFormErrorMessage("numberOfPieces")}
                                </div>
                            </div>
                            <div className={styles.formCol}>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="weight" className={classNames({ "p-error": isFormFieldValid("weight") }, "Label__Text")}>
                                        Weight of package
                                    </label>
                                    <InputText disabled={canEdit ? false : true} type="text" id="weight" name="weight" value={formik.values.weight} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("weight") }, "Input__RoundFile")} />

                                    {getFormErrorMessage("weight")}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="unit" className={classNames({ "p-error": isFormFieldValid("unit") }, "Label__Text")}>
                                        Unit
                                    </label>
                                    <select className={styles.selectInput} disabled={canEdit ? false : true} value={selectedUnit} onChange={(e) => setSelectedUnit(e.target.value)}>
                                        <option disabled selected>
                                            Please select a unit
                                        </option>
                                        <option value="lb">Lb</option>
                                        <option value="cu">Cu ft</option>
                                        <option value="kg">Kg</option>
                                    </select>
                                    {getFormErrorMessage("unit")}
                                </div>

                                <div className={styles.fieldGroup}>
                                    <label htmlFor="consigneeName" disabled={canEdit ? false : true} className={classNames({ "p-error": isFormFieldValid("consigneeName") }, "Label__Text")}>
                                        Consignee Name
                                    </label>
                                    <InputText
                                        type="text"
                                        disabled={canEdit ? false : true}
                                        id="consigneeName"
                                        name="consigneeName"
                                        value={formik.values.consigneeName}
                                        onChange={formik.handleChange}
                                        className={classNames({ "p-invalid": isFormFieldValid("name") }, "Input__RoundFile")}
                                    />

                                    {getFormErrorMessage("consigneeName")}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="status" className={classNames({ "p-error": isFormFieldValid("status") }, "Label__Text")}>
                                        Package Status
                                    </label>
                                    <select className={styles.selectInput} disabled={isDriver || viewOnly || checkingInvoiceConflict} value={selectedDeliveryStatus} onChange={(e) => handledeliveryStatus(e.target.value)}>
                                        <option disabled selected>
                                            Please select a status
                                        </option>
                                        {packageStatus?.map((client) => {
                                            return <option value={client?.name}>{client?.name}</option>;
                                        })}
                                    </select>
                                    {checkingInvoiceConflict && <span style={{ fontSize: "0.8rem", color: "#888" }}>Checking for existing invoices...</span>}

                                    {getFormErrorMessage("status")}
                                </div>

                                <div className={styles.fieldGroup}>
                                    <label htmlFor="courierName" className={classNames({ "p-error": isFormFieldValid("courierName") }, "Label__Text")}>
                                        Courier Name
                                    </label>
                                    <select className={styles.selectInput} disabled={canEdit ? false : true} value={selectedCouriers} onChange={(e) => setSelectedCouriers(e.target.value)}>
                                        <option disabled selected>
                                            Please select a courier
                                        </option>
                                        {couriers?.map((client) => {
                                            return <option value={client?._id}>{client?.courier?.businessName}</option>;
                                        })}
                                    </select>

                                    {getFormErrorMessage("courierName")}
                                </div>

                                <div className={styles.fieldGroup}>
                                    <label htmlFor="PackageType" className={classNames({ "p-error": isFormFieldValid("PackageType") }, "Label__Text")}>
                                        Package Type
                                    </label>
                                    <select className={styles.selectInput} disabled={canEdit ? false : true} value={selectedPackType} onChange={(e) => setSelectedPAckType(e.target.value)}>
                                        <option disabled selected>
                                            Please select a package Type
                                        </option>
                                        {PackageTypes?.map((client) => {
                                            return <option value={client}>{client}</option>;
                                        })}
                                    </select>

                                    {getFormErrorMessage("PackageType")}
                                </div>

                                <div className={styles.fieldGroup}>
                                    <label htmlFor="numberOfPieces" className={classNames({ "p-error": isFormFieldValid("numberOfPieces") }, "Label__Text")}>
                                        Number of pieces
                                    </label>
                                    <InputText
                                        disabled={canEdit ? false : true}
                                        id="numberOfPieces"
                                        name="numberOfPieces"
                                        value={formik.values.numberOfPieces}
                                        onChange={formik.handleChange}
                                        className={classNames({ "p-invalid": isFormFieldValid("numberOfPieces") }, "Input__Round")}
                                    />

                                    {getFormErrorMessage("numberOfPieces")}
                                </div>
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="price" className={classNames({ "p-error": isFormFieldValid("price") }, "Label__Text")}>
                                        Price
                                    </label>
                                    <InputText disabled={canEdit ? false : true} id="price" name="price" value={formik.values.price} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("price") }, "Input__Round")} />

                                    {getFormErrorMessage("price")}
                                </div>
                                {selectedShipment === "shipment" ? (
                                    <div className={styles.fieldGroup}>
                                        <label htmlFor="shipmentNumber" className={classNames({ "p-error": isFormFieldValid("shipmentNumber") }, "Label__Text")}>
                                            Shipment number
                                        </label>
                                        <InputText
                                            disabled={canEdit ? false : true}
                                            id="shipmentNumber"
                                            name="shipmentNumber"
                                            value={formik.values.shipmentNumber}
                                            onChange={formik.handleChange}
                                            className={classNames({ "p-invalid": isFormFieldValid("shipmentNumber") }, "Input__Round")}
                                        />

                                        {getFormErrorMessage("shipmentNumber")}
                                    </div>
                                ) : (
                                    <div className={styles.fieldGroup}>
                                        <label htmlFor="flightNumber" className={classNames({ "p-error": isFormFieldValid("flightNumber") }, "Label__Text")}>
                                            Flight Number
                                        </label>
                                        <InputText
                                            disabled={canEdit ? false : true}
                                            id="flightNumber"
                                            name="flightNumber"
                                            value={formik.values.flightNumber}
                                            onChange={formik.handleChange}
                                            className={classNames({ "p-invalid": isFormFieldValid("flightNumber") }, "Input__Round")}
                                        />

                                        {getFormErrorMessage("flightNumber")}
                                    </div>
                                )}
                                <div className={styles.fieldGroup}>
                                    <label htmlFor="notes" className={classNames({ "p-error": isFormFieldValid("notes") }, "Label__Text")}>
                                        Notes
                                    </label>
                                    <textarea
                                        disabled={canEdit ? false : true}
                                        id="notes"
                                        name="notes"
                                        value={formik.values.notes}
                                        onChange={formik.handleChange}
                                        className={classNames({ "p-invalid": isFormFieldValid("notes") }, "Input__Round", styles.textareaInput)}
                                    />

                                    {getFormErrorMessage("notes")}
                                </div>
                            </div>
                        </div>
                        {images?.length > 0 && (
                            <div className={styles.fieldGroup}>
                                <label htmlFor="price" className={classNames({ "p-error": isFormFieldValid("price") }, "Label__Text")}>
                                    Notes Images
                                </label>
                                <div className={styles.imagesRow}>
                                    {images?.map((image, index) => (
                                        <div className={styles.imageTile} key={index}>
                                            {!isDriver && (
                                                <span className={styles.imageRemove} onClick={() => handleRemove(index)}>
                                                    ×
                                                </span>
                                            )}
                                            <img src={image} alt="Note" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {brandData?.invoiceImage && (
                            <div className={styles.fieldGroup}>
                                <label htmlFor="price" className={classNames({ "p-error": isFormFieldValid("price") }, "Label__Text")}>
                                    Invoice Image
                                </label>
                                {invoiceImgError ? (
                                    <a href={brandData.invoiceImage} target="_blank" rel="noopener noreferrer" className={styles.invoiceFallbackLink}>
                                        <i className="pi pi-file" /> Open uploaded invoice
                                    </a>
                                ) : (
                                    <div className={styles.imagesRow}>
                                        <div className={styles.imageTile} style={{ width: "320px" }}>
                                            <img src={brandData?.invoiceImage} alt="Invoice" style={{ height: "auto", objectFit: "contain" }} onError={() => setInvoiceImgError(true)} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {role !== "client" && !isDriver && (
                            <div className="Down__Btn">
                                <Button label="Cancel" className="Btn__Transparent" onClick={handleCancel} />
                                <Button label="Update" className="Btn__Dark" type="submit" disabled={viewOnly} />
                            </div>
                        )}
                    </form>
                </div>
            </div>
            <InvoiceConflictDialog visible={showInvoiceConflict} conflicts={invoiceConflict} mode="statusChange" onProceedAnyway={handleProceedStatusOnly} onRemoveAndContinue={handleCancelInvoiceConflict} onCancel={handleCancelInvoiceConflict} />
        </div>
    );
}

export default Package;
